export const FILE_STORAGE_NAMESPACE = 'ppn-file-attachments';

// Generate a unique key for file storage
export const getFileStorageKey = (objectiveId, taskId, selectedWeek) => {
  // ✅ All three values must be present and match
  return `ppn_files_${objectiveId}_${taskId}_${selectedWeek}`;
};

// Save files to DataStore
export const saveFilesToDataStore = async (engine, key, files) => {
  try {
    const response = await engine.mutate({
      resource: `dataStore/${FILE_STORAGE_NAMESPACE}/${key}`,
      type: 'update',
      data: {
        files: files,
        lastUpdated: new Date().toISOString(),
        version: 1
      }
    });
    return response;
  } catch (error) {
    // If update fails, try create
    if (error.message?.includes('404') || error.httpStatus === 404) {
      return await engine.mutate({
        resource: `dataStore/${FILE_STORAGE_NAMESPACE}/${key}`,
        type: 'create',
        data: {
          files: files,
          lastUpdated: new Date().toISOString(),
          version: 1
        }
      });
    }
    throw error;
  }
};

// Load files from DataStore
export const loadFilesFromDataStore = async (engine, key) => {
  try {
    const response = await engine.query({
      files: {
        resource: `dataStore/${FILE_STORAGE_NAMESPACE}/${key}`,
      }
    });
    return response.files?.files || [];
  } catch (error) {
    // Return empty array if no files found
    if (error.message?.includes('404') || error.httpStatus === 404) {
      return [];
    }
    throw error;
  }
};

// Delete files from DataStore
export const deleteFilesFromDataStore = async (engine, key) => {
  try {
    await engine.mutate({
      resource: `dataStore/${FILE_STORAGE_NAMESPACE}/${key}`,
      type: 'delete',
    });
    return true;
  } catch (error) {
    console.warn('Failed to delete files:', error);
    return false;
  }
};

// Initialize the DataStore namespace
export const initializeFileStorage = async (engine) => {
  try {
    // Check if namespace exists
    await engine.query({
      namespace: {
        resource: `dataStore/${FILE_STORAGE_NAMESPACE}`,
      }
    });
    console.log('✅ File storage namespace exists');
  } catch (error) {
    // Create namespace if it doesn't exist
    try {
      await engine.mutate({
        resource: 'dataStore',
        type: 'create',
        data: {
          key: FILE_STORAGE_NAMESPACE,
        }
      });
      console.log('✅ File storage namespace created');
    } catch (createError) {
      console.warn('Namespace may already exist:', createError);
    }
  }
};